/** The WhatsApp workspace endpoint the Inbox is scoped to, per organization. */
export interface InboxWorkspaceScope {
  organizationId: number;
  endpointId: number | null;
}

/**
 * The first resolution for an organization (including after an organization switch)
 * is a baseline: the server already scoped the Inbox list, so nothing is rescoped.
 * Only an endpoint change within the same organization is a real workspace switch.
 * A failed load is recorded as `endpointId: null`.
 */
export function nextInboxWorkspaceScope(
  previous: InboxWorkspaceScope | null,
  organizationId: number,
  endpointId: number | null,
): { nextScope: InboxWorkspaceScope; shouldBump: boolean } {
  const nextScope = { organizationId, endpointId };
  if (previous == null || previous.organizationId !== organizationId) {
    return { nextScope, shouldBump: false };
  }
  return { nextScope, shouldBump: previous.endpointId !== endpointId };
}
